// extracted by mini-css-extract-plugin
module.exports = {"header":"_33974c2b58--header--AkTGE","heart":"_33974c2b58--heart--PSDxx","body":"_33974c2b58--body--HBy2Z","close":"_33974c2b58--close--zDnoL"};